import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';
import SectionHeading from '@/components/base/SectionHeading';
import { themeDot, themeSoft } from '@/utils/theme';
import type { ThemeKey } from '@/types/content';

export default function CategoryGrid() {
  return (
    <section id="categories" className="bg-background-50 border-b border-background-200 scroll-mt-28">
      <div className="px-4 md:px-8 py-12 md:py-16">
        <SectionHeading
          eyebrow="COLUMNS"
          title="按栏目找到你要的线索"
          desc="五个栏目覆盖不同领域，每个栏目都由专人跟进，保证事件脉络清晰可追。"
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((c) => {
            const count = articles.filter((a) => a.category === c.slug).length;
            const theme = c.theme as ThemeKey;
            return (
              <Link
                key={c.slug}
                to={`/category/${c.slug}`}
                className="group block p-6 rounded-lg border border-background-200 bg-background-50 hover:border-primary-300 transition-colors cursor-pointer"
              >
                <div className="flex items-start justify-between">
                  <span className={`w-12 h-12 rounded-lg flex items-center justify-center text-2xl ${themeSoft[theme]}`}>
                    <i className={c.icon}></i>
                  </span>
                  <span className="text-xs text-foreground-400 font-label tracking-wider">{c.en}</span>
                </div>
                <h3 className="mt-5 font-heading font-bold text-lg text-foreground-950 group-hover:text-primary-700 transition-colors">
                  {c.name}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">{c.desc}</p>
                <div className="mt-5 flex items-center justify-between text-xs">
                  <span className="flex items-center gap-1.5 text-foreground-500">
                    <span className={`w-1.5 h-1.5 rounded-full ${themeDot[theme]}`}></span>
                    {count} 篇线索整理
                  </span>
                  <span className="flex items-center gap-1 text-primary-700">
                    进入栏目
                    <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                  </span>
                </div>
              </Link>
            );
          })}
          <div className="p-6 rounded-lg bg-foreground-950 text-background-50 flex flex-col justify-center">
            <i className="ri-quill-pen-line text-2xl text-primary-400 mb-3"></i>
            <h3 className="font-heading font-bold text-lg">没找到相关线索？</h3>
            <p className="mt-2 text-sm text-background-200/80 leading-relaxed">
              把关键词告诉我们，编辑会优先跟进你关心的方向。
            </p>
            <Link
              to="/contact"
              className="mt-5 inline-flex w-fit items-center gap-1.5 text-sm text-primary-300 hover:text-primary-200 cursor-pointer whitespace-nowrap"
            >
              提交线索方向
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}